import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as allActions from "./actions";

/**
 * Hook providing bound action creators for the offerHistory Redux slice.
 * @returns {Object} Bound action creators: updateOfferHistory, updateOfferHistoryFilters, setOfferHistoryFilters, loadOfferHistoryFilters, clearOfferHistoryFilters
 */
export function useOfferHistoryActions() {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(allActions, dispatch), [dispatch]);
}
